<template>
	<div class="form-container">
		<el-form class="public-big-form" ref="form" :model="form" :rules="rules">
			<el-form-item prop="student_name" :error="formError.student_name">
				<el-input v-model="form.student_name" size="small" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item prop="exam_number" :error="formError.exam_number">
				<el-input v-model="form.exam_number" size="small" placeholder="请输入准考证号"></el-input>
			</el-form-item>
			<el-form-item prop="captcha_value" :error="formError.captcha_value">
				<el-row :gutter="12">
					<el-col :span="12">
						<el-input v-model="form.captcha_value" size="small" placeholder="请输入计算结果" clearable @keyup.native.enter="submit"></el-input>
					</el-col>
					<el-col :span="8">
						<div class="captcha-wrapper" @click="getCaptcha">
							<img :src="captcha_img" alt title="点击更换验证码" />
						</div>
					</el-col>
					<el-col :span="4">
						<span @click="getCaptcha" style="cursor:pointer">更换</span>
					</el-col>
				</el-row>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="query" :loading="loading">查询</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
import { captcha } from '@/api/user';
export default {
	data() {
		return {
			form: {
				student_name: '',
				exam_number: '',
				captcha_key: '',
				captcha_value: ''
			},
			captcha_img: '',
			rules: {},
			rules: {
				student_name: [
					{
						required: true,
						message: '姓名不能为空',
						trigger: 'blur'
					}
				],
				exam_number: [
					{
						required: true,
						message: '准考证不能为空',
						trigger: 'blur'
					}
				],
				captcha_value: [
					{
						required: true,
						message: '请输入计算结果',
						trigger: 'blur'
					}
				]
			}
		};
	},
	props: {
		formError: {
			type: Object,
			default() {
				return {};
			}
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.getCaptcha();
	},
	methods: {
		query() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.$emit('on-query', this.form);
				} else {
					this.$notify.error({
						message: '请检查输入'
					});
					return false;
				}
			});
		},
		getCaptcha() {
			this.form.captcha_key = '';
			this.form.captcha_value = '';
			captcha().then(res => {
				if (res && res.code === 200) {
					this.captcha_img = res.data.img;
					this.form.captcha_key = res.data.key;
				}
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.form-container {
	border: 1px solid #eaeaea;
	padding: 40px 0;
	margin-top: 20px;
	.public-big-form {
		width: 60%;
		margin: 0 auto;
	}
}
@media screen and (max-width: 768px) {
	.form-container {
		padding: 20px 0;
		.public-big-form {
			width: 90%;
		}
	}
}
</style>
